const SearchTypes = {
    CHANGE_FULL_SEARCH_VALUE:'CHANGE_FULL_SEARCH_VALUE',
    GET_FULL_SEARCH_START:'GET_FULL_SEARCH_START',
    GET_FULL_SEARCH_SUCCESS:'GET_FULL_SEARCH_SUCCESS',
    GET_FULL_SEARCH_FAILED:'GET_FULL_SEARCH_FAILED',
    CHANGE_FULL_SEARCH_STATE:'CHANGE_FULL_SEARCH_STATE'
}

export default SearchTypes